import React from 'react'
import NavProps from './categoricomp/navprops'
import './style.css'

export default function navbar() {

    return (
        <div className="category-navbar">
            <NavProps
            inheading="Toko"
            inspan="Muhammad Rifqi Mubarak"
            />        
        </div>
    )
}
